export type UnitConverterFn = (value: number, targetSize?: number, defaultSize?: number) => number;

export const priceUnitConverter: UnitConverterFn = (value, targetSize, valueSize) =>
  (value * (targetSize || 1)) / (valueSize || 1);

export const qtyUnitConverter: UnitConverterFn = (value, targetSize, valueSize) =>
  (value * (valueSize || 1)) / (targetSize || 1);
